import { LitElement, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './nuvance-leadership-container.global.pcss?inline';
import innerStyles from './nuvance-leadership-container.inner.pcss?inline';

/**
 * The Nuvance Leadership Container component
 * @element nuvance-leadership-container
 * @slot header - Named slot for the header above the container.
 * @slot featured - Named slot for the featured leadership item.
 * @slot grid - Named slot for the leadership items displayed in a grid format.
 */
@customElement('nuvance-leadership-container')
export class NuvanceLeadershipContainer extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  render(): TemplateResult {
    return html`
      <div class="nuvance-leadership-container">
        <slot name="header"></slot>
        <slot name="featured"></slot>
        <div class="grid">
          <slot name="grid"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-leadership-container': NuvanceLeadershipContainer;
  }
}
